export const HOME_PAGE_NAME = "home";

export const DEVHUB_PAGE_NAME = "dev-hub";
export const FAQ_PAGE_NAME = "faq";
export const BUY_PAGE_NAME = "buy";
export const SEARCH_PAGE_NAME = "search";
export const DEV_PROFILES_PAGE_NAME = "dev-profiles";

export const ARTICLE_PAGE = "article-page";
export const ARTICLE_PAGE_PREVIEW = "article-page-preview";

export const NOT_FOUND_PAGE_NAME = "not-found";

export const SURVIVOR_GAMEZ = "survivor-gamez";
